// extracted by mini-css-extract-plugin
export var chip = "_ef-0";
export var filterDropdown = "_ef-5";
export var filterItem = "_ef-6";
export var icon = "_ef-1";
export var removeButton = "_ef-3";
export var removeIcon = "_ef-4";
export var separator = "_ef-2";